import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(main)/about-us/consume.tsx");
